import { useState } from 'react';
import { copyToClipboard } from '@/lib/utils/clipboard';

interface BrandColorCardProps {
  hex: string;
  name: string;
  meaning: string;
}

export function BrandColorCard({ hex, name, meaning }: BrandColorCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void copyToClipboard(hex);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      onClick={handleCopy}
      className="group text-left w-full focus:outline-none"
      title={`Copiar ${hex}`}
    >
      <div className="relative overflow-hidden rounded-xl border border-gray-200 dark:border-gray-800 transition-all duration-300 hover:shadow-lg hover:-translate-y-1">
        {/* Color swatch */}
        <div
          className="h-24 sm:h-28 w-full transition-transform duration-300 group-hover:scale-105"
          style={{ backgroundColor: hex }}
        />

        {/* Info */}
        <div className="bg-white dark:bg-gray-900 p-3">
          <p className="text-xs font-bold text-gray-900 dark:text-white truncate">{name}</p>
          <p className="text-[11px] font-mono text-gray-400 dark:text-gray-500 mt-0.5">
            {copied ? 'Copiado!' : hex}
          </p>
          <p className="text-[11px] text-gray-400 dark:text-gray-500 mt-1 italic">{meaning}</p>
        </div>
      </div>
    </button>
  );
}
